import React, {useRef,useState,useEffect} from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { fetchWeather } from '../Redux/Actions';
import logo1 from "../weather bg.jpg";
import logo2 from "../wind image.jpg";
import logo3 from "../humidity image.png";
import sunnyImage from "../sunny image.png";
import cloudyImage from "../cloudyImage.png";
import rainyImage from "../rainyImage.png";
import coldImage from "../coldImage.png"

function WeatherApp() {
  const [city, setCity] = useState("");
  const weatherSelector = useSelector((state) => state);
  const dispatch = useDispatch();
  const inputRef = useRef('');
  const getWeatherReducerAction = (city) => dispatch(fetchWeather(city));

  useEffect(() => {
    const storedCityName = localStorage.getItem('city');
    if ( storedCityName) {
      getWeatherReducerAction(storedCityName);
      localStorage.getItem('city', storedCityName);
    } else {
      getWeatherReducerAction('Karimnagar');
      localStorage.getItem('city', 'Karimnagar');
    }
    }, []  );
  
    

  const getWeatherReducer = (event) => {
    event.preventDefault();
    if(city === "") {
        alert("Enter a city name")
    } else {
      getWeatherReducerAction(city);
      console.log(weatherSelector.weatherinfo);
      inputRef.current.value = '';
      localStorage.setItem('city',city);
    }
  };

  let weatherImage;
  if (weatherSelector.weatherinfo && weatherSelector.weatherinfo.main) {
    const temperature = Math.round (weatherSelector.weatherinfo.main.temp);
    if (temperature >25) {
      weatherImage = sunnyImage;
    } else if (temperature >=20 && temperature <= 25) {
      weatherImage = cloudyImage;
    } else if (temperature >=10 && temperature <= 20) {
      weatherImage = rainyImage;
    } else {
      weatherImage = coldImage;
    }
    localStorage.setItem('temperature',temperature);
  }
  
  return (
    <div className="container">
      <img className='logo1' src={logo1} alt="background" />
      <div className="weather">
        <div className="title">
          <h1> Weather App</h1>
        </div>
        <div className="search">
          <input type="text" placeholder="Enter City Name" autoComplete="off" onChange={e => setCity(e.target.value)} ref={inputRef} />
          <button className='button' onClick={getWeatherReducer}>Search</button>
        </div>
        { weatherSelector.weatherinfo && weatherSelector.weatherinfo.main ? (
        <div className="info">
          <img src= {weatherImage} alt="weather" className="icon" />
          <h1>{Math.round(weatherSelector.weatherinfo.main.temp)}&#176;c</h1>
          <h2>{weatherSelector.weatherinfo.name}</h2>
          <div className="details">
            <div className="col">
              <img src={logo3} alt="humidity" />
              <div className="humidity">
                <p>{Math.round(weatherSelector.weatherinfo.main.humidity)}%</p>
                <p>Humidity</p>
              </div>
            </div>
            <div className="col">
              <img src={logo2} alt="wind" />
              <div className="wind">
                <p>{Math.round(weatherSelector.weatherinfo.wind.speed)} Km/h</p>
                <p>Wind</p>
              </div>
            </div>
          </div>
        </div>
        ) : ( 
        <p>Enter a city name correctly</p>
        )
        }
      </div>
    </div>
  )
}

export default WeatherApp;





  


